import useMobileLayout from '@/hooks/use-mobile-layout';
import useChatWidgetLockedFullscreen from './use-chat-widget-locked-fullscreen';
import useChatWidgetOpen from './use-chat-widget-open';
import useInvestigationDock from './use-investigation-dock';

// Route-implied opens never persist. On mobile, keep investigation content visible
// until the user opens Percy; the desktop investigation can show both side by side.
const useChatWidgetEffectiveOpen = () => {
  const isMobile = useMobileLayout();
  const {
    isOpen
  } = useChatWidgetOpen();
  const lockedFullscreen = useChatWidgetLockedFullscreen();
  const lockedSidebar = useInvestigationDock();
  return isOpen || lockedFullscreen || lockedSidebar && !isMobile;
};
export default useChatWidgetEffectiveOpen;